import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { UserDetailsModel } from "@theStellarBlueprint/CustomApiModels";
import {
    PurchasedItemsConfigParameter,
} from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigState";

const enum configKey {
    page = "page",
    Search = "Search",
    Description = "Description",
    pageSize = "pageSize",
    fromDate = "fromDate",
    toDate = "toDate",
}

const userDetailsUrl = "api/v1/OrderHistoryItems";

export interface QueryParameters {
    [key: string]: string;
}
export async function getPurchasedItems(purchasedItemsConfig: PurchasedItemsConfigParameter) {
    const queryStringParameters: QueryParameters = {};
    const page = purchasedItemsConfig[configKey.page];
    const Search = purchasedItemsConfig[configKey.Search];
    const Description = purchasedItemsConfig[configKey.Description];
    const pageSize = purchasedItemsConfig[configKey.pageSize];
    const fromDate = purchasedItemsConfig[configKey.fromDate];
    const toDate = purchasedItemsConfig[configKey.toDate];
    if (page && page !== "") {
        queryStringParameters[configKey.page] = page;
    }
    if (Search && Search !== "") {
        queryStringParameters[configKey.Search] = Search;
    }
    if (Description && Description !== "") {
        queryStringParameters[configKey.Description] = Description;
    }
    if (pageSize && pageSize !== "") {
        queryStringParameters[configKey.pageSize] = pageSize;
    }
    if (fromDate && fromDate !== "") {
        queryStringParameters[configKey.fromDate] = fromDate;
    }
    if (toDate && toDate !== "") {
        queryStringParameters[configKey.toDate] = toDate;
    }
    const purchasedItemsModel = await get<UserDetailsModel>(`${userDetailsUrl}`, undefined, queryStringParameters);
    return purchasedItemsModel;
}